var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducationEquality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.159 4.3374C19.7232 4.0849 21.3046 3.95451 22.889 3.9474C23.0254 3.94656 23.1573 3.99646 23.259 4.0874C23.3547 4.18279 23.4087 4.31226 23.409 4.4474L23.409 20.1974C23.4064 20.3292 23.3529 20.4549 23.2597 20.5481C23.1665 20.6413 23.0408 20.6948 22.909 20.6974C14.619 20.8174 12.159 23.4474 12.159 23.4474M12.159 23.4474L12.159 6.6774C12.159 6.6774 9.709 4.0574 1.429 3.9474C1.29257 3.94656 1.1607 3.99646 1.059 4.0874C0.963277 4.18279 0.909328 4.31226 0.908997 4.4474L0.908997 20.1974C0.911557 20.3292 0.965057 20.4549 1.05828 20.5481C1.15149 20.6413 1.27719 20.6948 1.409 20.6974C9.699 20.8174 12.159 23.4474 12.159 23.4474Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.159 22.9574C12.3152 21.6594 12.8911 20.448 13.799 19.5074C14.9595 18.2519 16.4843 17.3916 18.159 17.0474L18.159 1.4374C18.1593 1.35638 18.1382 1.27672 18.0978 1.20648C18.0574 1.13624 17.9992 1.07791 17.929 1.0374C17.8563 0.993219 17.7749 0.965019 17.6905 0.954674C17.606 0.944329 17.5203 0.952077 17.439 0.977403C16.0371 1.37849 14.776 2.16498 13.799 3.2474C12.9066 4.19078 12.333 5.39053 12.159 6.6774",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.158997 0.197388)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationEquality);
export default __webpack_public_path__ + "static/media/education_equality.b705d70b.svg";
export { ForwardRef as ReactComponent };